import React from 'react';
import { partial } from 'lodash';
import cx from 'classnames';
import PropTypes from 'prop-types';
import styles from './styles.module.styl';
import BooleanFeedbackButton from './BooleanFeedbackButton';

const FeedbackFooterMode = {
  READY: 'READY',
  INPUT: 'INPUT',
  THANKS: 'THANKS'
};

const FeedbackButtonSelected = {
  NONE: 'NONE',
  YES: 'YES',
  NO: 'NO'
};

const initialState = {
  mode: FeedbackFooterMode.READY,
  selected: FeedbackButtonSelected.NONE,
  comment: ''
};

class FeedbackSection extends React.Component {
  state = { ...initialState }

  componentWillReceiveProps(nextProps) {
    if (this.props.articleUrl !== nextProps.articleUrl) {
      this.setState({ ...initialState });
    }
  }

  trackData = (eventName, data) => {
    const title = document.title.split('-').length > 0 ? document.title[0].trim() : document.title;

    this.context.trackEvent(eventName, {
      path: window.location.pathname,
      url: window.location.toString(),
      title,
      referrer: document.referrer,
      ...data
    });
  }

  handleCommentChange = (e) => {
    this.setState({
      comment: e.target.value
    });
  }

  handleBooleanFeedback = (isPositive) => {
    if (this.state.mode === FeedbackFooterMode.READY) {
      this.trackData('feedback:submit', { value: isPositive });

      this.setState({
        mode: FeedbackFooterMode.INPUT,
        selected: isPositive ? FeedbackButtonSelected.YES : FeedbackButtonSelected.NO
      });
    }
  }
  handlePositiveFeedback = partial(this.handleBooleanFeedback, true);
  handleNegativeFeedback = partial(this.handleBooleanFeedback, false);

  handleCommentFeedback = (evt) => {
    evt.preventDefault();
    this.sendCommentFeedback(
      this.state.selected === FeedbackButtonSelected.YES,
      this.state.comment
    );
    this.setState({ mode: FeedbackFooterMode.THANKS });
  }

  sendCommentFeedback(positive, comment) {
    $.post('/docs/submit-feedback', {
      page_title: document.title,
      page_url: window.location.href,
      positive,
      comment
    });
    this.trackData('feedback:submit-comment', {
      value: positive,
      trackData: comment
    });
  }

  render() {
    const { isQuickstart } = this.props;
    const { mode, selected } = this.state;

    const thanksTitle = 'Thanks you for your feedback!';
    const readyTitle = isQuickstart ? 'Did it work?' : 'Was this article helpful?';
    const title = mode === FeedbackFooterMode.THANKS ? thanksTitle : readyTitle;

    return (
      <div>
        <div className={styles.topContent}>
          <div>
            <h5 className={styles.title}>{title}</h5>
            {mode !== FeedbackFooterMode.THANKS &&
              <div className={styles.buttons}>
                <BooleanFeedbackButton
                  isPositive
                  isActive={selected === FeedbackButtonSelected.YES}
                  isDisabled={selected === FeedbackButtonSelected.NO}
                  handleClick={this.handlePositiveFeedback}
                  iconCode="470"
                />
                <BooleanFeedbackButton
                  isActive={selected === FeedbackButtonSelected.NO}
                  isDisabled={selected === FeedbackButtonSelected.YES}
                  handleClick={this.handleNegativeFeedback}
                  iconCode="471"
                />
              </div>
            }
          </div>
          <div className={styles.suggestions}>
            <span>Any suggestion or typo? </span>
            <a
              className={styles.editLink}
              href={this.props.githubEditLink}
              onClick={() => this.trackData('click:edit-github')}
              target="_blank"
              rel="noreferrer noopener nofollow"
            >
              Edit on GitHub
            </a>
          </div>
        </div>
        {mode === FeedbackFooterMode.INPUT &&
          <div className={styles.feedbackForm}>
            <form className="clearfix" onSubmit={this.handleCommentFeedback}>
              <textarea
                onChange={this.handleCommentChange}
                className={cx('form-control', styles.textArea)}
                rows="3"
                placeholder={selected === FeedbackButtonSelected.YES ? 'Glad to hear that! Any way we can improve?' : 'Sorry to hear that. How can we help you?'}
              />
              <button
                type="submit"
                className="btn btn-primary"
                disabled={!this.state.comment}
              >
                Send
              </button>
              <div className={styles.communitySection}>
                {'Can\'t find what you are looking for?  Check out '}
                <a
                  href="https://community.auth0.com/"
                  onClick={() => this.trackData('click:view-community')}
                  target="_blank"
                  rel="noreferrer noopener"
                >Auth0 Community</a>
              </div>
            </form>
          </div>
        }
      </div>
    );
  }
}

FeedbackSection.contextTypes = {
  trackEvent: PropTypes.func.isRequired
};

FeedbackSection.propTypes = {
  articleUrl: PropTypes.string,
  githubEditLink: PropTypes.string,
  isQuickstart: PropTypes.bool.isRequired
};

FeedbackSection.defaults = {
  isQuickstart: false
};

export default FeedbackSection;
